import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { HomeService } from '../../services/home.service';
import { MatDialog } from '@angular/material/dialog';
import { CloseAlertComponent } from '../../stores/alerts-notify/close-alert/close-alert.component';
import { timestampFormat } from '../../../config/moment';

@Component({
  selector: 'app-alerts-dropdown',
  templateUrl: './alerts-dropdown.component.html',
  styleUrls: ['./alerts-dropdown.component.scss']
})
export class AlertsDropdownComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Output() toggleDropdown = new EventEmitter<void>();

  public alerts: any = [];
  public closedAlertIds: number[] = [];
  public timestampFormat = timestampFormat;
  public unreadCount: number = 0;

  constructor(
    private alertsService: AlertsService,
    private homeService: HomeService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadAlerts();
    this.retrieveClosedAlertIds();
  }

  loadAlerts() {
    this.alertsService.getalerts().subscribe((res) => {
      if (res.data) {
        this.alerts = res.data.data
          .filter((alert: any) => !this.closedAlertIds.includes(alert.id))
          .slice(0, 5); // Show only latest 5
        this.updateUnreadCount();
      }
    });
  }

  retrieveClosedAlertIds() {
    this.closedAlertIds = JSON.parse(localStorage.getItem('closedAlertIds') || '[]');
  }

  updateUnreadCount() {
    this.unreadCount = this.alerts.length;
  }

  onToggleDropdown(event: Event) {
    event.stopPropagation();
    this.toggleDropdown.emit();
  }

  openDialog(alert: any): void {
    const dialogRef = this.dialog.open(CloseAlertComponent, {
      data: {
        cabinet_name: alert.cabinet_name,
        product_name: alert.product_name,
        status: alert.status,
        count: alert.count,
        id: alert.id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.closeAlert(alert);
      }
    });
  }

  closeAlert(alert: any): void {
    this.homeService.closeAlert(alert.id).subscribe((res) => {
      if (res.success) {
        const index = this.alerts.indexOf(alert);
        if (index !== -1) {
          this.alerts.splice(index, 1);
          this.closedAlertIds.push(alert.id);
          localStorage.setItem('closedAlertIds', JSON.stringify(this.closedAlertIds));
          this.updateUnreadCount();
        }
      }
    });
  }

  navigateToAlertList(event: Event) {
    event.stopPropagation();
    this.router.navigate(['/home/notify/alert']);
    this.onToggleDropdown(event);
  }

  navigateToCabinet(cabinetId: number, event: Event) {
    event.stopPropagation();
    this.router.navigate(['/home/stocks/cabinets', cabinetId]);
    this.onToggleDropdown(event);
  }

  navigateToProduct(cabinetId: number, event: Event) {
    event.stopPropagation();
    this.router.navigate(['/home/stocks/products', cabinetId]);
    this.onToggleDropdown(event);
  }
} 